var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "-3 -3 26 26"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 13,
    fill: "#30CB22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.833 9.167c0-.682 0-1.308-.127-1.614-.126-.307-.367-.548-.849-1.03L10.91 2.578c-.416-.416-.624-.624-.881-.747a2 2 0 0 0-.165-.068c-.269-.095-.563-.095-1.15-.095-2.705 0-4.057 0-4.973.738q-.278.225-.503.503C2.5 3.824 2.5 5.176 2.5 7.88v3.787c0 3.142 0 4.714.976 5.69.977.976 2.548.976 5.69.976h6.667M10 2.083V2.5c0 2.357 0 3.536.732 4.268S12.643 7.5 15 7.5h.417"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.499 11.667h-1.667a.833.833 0 0 0-.833.833v1.25m0 0v2.083m0-2.083h2.083m-11.25 2.083v-1.666m0 0v-2.5h1.25a1.25 1.25 0 0 1 0 2.5zm4.583-2.5h1.072c.789 0 1.428.622 1.428 1.389v1.388c0 .767-.64 1.39-1.428 1.39h-1.072z"
  })));
};
export default SvgPdf;